import { Controller } from "@hotwired/stimulus"

// The reply box on a live conversation page. Its editor is
// data-turbo-permanent, so a half-written reply survives the page refreshing
// itself when the other side sends a message (Inquiries::Broadcast) — which
// also means nothing resets it after sending, so this empties it once the
// message has gone. A failed send keeps the draft.
export default class extends Controller {
  sent(event) {
    if (!event.detail.success) return

    const editor = this.element.querySelector("lexxy-editor")
    if (editor) editor.value = ""
  }
}
